import { render, staticRenderFns } from "./Cross.vue?vue&type=template&id=52ff3760&scoped=true&"
import script from "./Cross.vue?vue&type=script&lang=js&"
export * from "./Cross.vue?vue&type=script&lang=js&"
import style0 from "./Cross.vue?vue&type=style&index=0&id=52ff3760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff3760",
  null
  
)

export default component.exports